import { render } from "./EmployeeView.vue?vue&type=template&id=459a4302&ts=true"
import script from "./EmployeeView.vue?vue&type=script&lang=ts"
export * from "./EmployeeView.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Development\\Casa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__